var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.64,12a4.37,4.37,0,0,1,7.45-3.09l5.28-5.28a2.16,2.16,0,0,0-.65-.43L12.77.32a2,2,0,0,0-1.54,0L4.28,3.2A2,2,0,0,0,3.2,4.28l-2.88,7a2,2,0,0,0,0,1.54l2.88,7a2.16,2.16,0,0,0,.43.65l5.28-5.28A4.34,4.34,0,0,1,7.64,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.23,23.68a2,2,0,0,0,1.54,0l7-2.88a2,2,0,0,0,1.08-1.08l2.88-6.95a2,2,0,0,0,0-1.54L20.8,4.28a2.16,2.16,0,0,0-.43-.65L15.09,8.91a4.37,4.37,0,0,1-6.18,6.18L3.63,20.37a2.16,2.16,0,0,0,.65.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentsActive);
export default __webpack_public_path__ + "static/media/agents-active.845c346dd32e44f1152f16a084b47c61.svg";
export { ForwardRef as ReactComponent };